// AgentNode.js
import React from "react";
import { Handle } from "reactflow";
import { FiUser } from 'react-icons/fi'; // Example: Using react-icons, install if needed (npm install react-icons)

const AgentNode = ({ id, data }) => {
  const statusStyles = {
    idle: "border-zinc-600", // Default border
    pending: "border-yellow-400",
    queued: "border-blue-400",
    failed: "border-red-500",
    success: "border-green-500",
    running: "border-green-500 animate-pulse", // Pulse the border for running
    approvalNeeded: "border-orange-500 animate-[glow_1.5s_infinite]",
    diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
  };

  const status = data?.status || "idle";
  const currentBorderColor = statusStyles[status] || statusStyles.idle;
  const isLoading = status === "running" || status === "pending";

  return (
    <div
      className={`relative w-48 h-28 bg-zinc-800 rounded-xl shadow-xl border-2 ${currentBorderColor} flex flex-col items-center justify-center p-3 transition-colors duration-300 ease-in-out`}
    >
      {/* Agent Icon */}
      <div className="mb-2 p-2 bg-zinc-700 rounded-full">
        {/* Placeholder for a more specific agent icon */}
        <FiUser className="w-6 h-6 text-blue-400" />
      </div>

      {/* Agent Name */}
      <div
        className="text-sm font-medium text-zinc-100 text-center w-full truncate px-1"
        title={data?.agent_name || "Select Agent"}
      >
        {data?.agent_name || "N/A"}
      </div>
      
      {/* Small "Agent" label */}
       <div className="text-xs text-zinc-400 mt-1">
        Agent
      </div>

      {/* Loading Indicator (Optional, can be part of status styling) */}
      {isLoading && (
        <div className="absolute top-2 right-2 animate-spin h-3 w-3 border-2 border-zinc-400 border-t-white rounded-full" />
      )}

      {/* Output Handle */}
      <Handle
        type="source"
        position="bottom"
        className="!bg-[#5652CF] !border-none !shadow-md"
        style={{
          bottom: "-6px", // Slightly offset for better visibility against the border
           height: "10px", width: "10px",
          borderRadius: "50%",
        }}
      />
    </div>
  );
};

export default AgentNode;